export default (priceTypeString) => [
  {
    type: 'checkbox',
    align: 'center',
    width: 40,
  },
  {
    field: 'minMatch',
    align: 'center',
    minWidth: 150,
    title: '(>)区间下限',
    editRender: {
      name: 'ElInputNumber',
      attrs: {
        placeholder: '请输入区间下限',
      },
    },
  },
  {
    field: 'maxMatch',
    align: 'center',
    minWidth: 150,
    title: '(<=)区间上限',
    editRender: {
      name: 'ElInputNumber',
      attrs: {
        placeholder: '请输入区间上限',
      },
    },
  },
  {
    field: 'price',
    align: 'center',
    minWidth: 100,
    title: priceTypeString,
    editRender: {
      name: 'ElInputNumber',
      attrs: {
        precision: 4,
        placeholder: '请输入单价',
      },
    },
  },
]
